import * as types from '../constants';

export function fileDownload(fileUUID, file_type) {
  return {
    type: types.FILE_DOWNLOAD,
    fileUUID,
    file_type,
  };
}

export function fileContentCopy(fileUUID) {
  return {
    type: types.FILE_CONTENT_COPY,
    fileUUID,
  };
}

export function loadResultFile(fileUUID) {
  return {
    type: types.LOAD_RESULT_FILE,
    fileUUID,
  };
}
